import { gql } from "@apollo/client";

export const GET_GRAPHIC_STANDS = gql`
  query GetGraphicStands($filter: JsonObject) {
    graphicStands(filter: $filter) {
      id
      exhibitor
      hall_name
      block
      corridor
      stand_number
      status
      created_at
      updated_at
      complete_at
      graphic_list_id
      comment
      relStand {
        id
        shelf_number
      }
      relPackedUser {
        id
        name
        surname
      }
      relGraphicList {
        id
        title
      }
    }
  }
`;

export const GET_GRAPHIC_STAND = gql`
  query GetGraphicStand($id: ID!) {
    graphicStand(id: $id) {
      id
      exhibitor
      hall_name
      block
      corridor
      stand_number
      status
      created_at
      updated_at
      graphic_list_id
      complete_at
      comment
      relStand {
        id
        shelf_number
      }
      relPackedUser {
        id
        name
        surname
      }
      relGraphicList {
        id
        title
      }
    }
  }
`;

export const GET_GRAPHIC_STANDS_CURSOR = gql`
  query GetGraphicStandsCursor(
    $first: Int
    $after: String
    $orderBy: [QueryGraphicStandsCursorOrderByRelationOrderByClause!]
    $text: String
    $where: QueryGraphicStandsCursorWhereWhereConditions
  ) {
    graphicStandsCursor(
      first: $first
      after: $after
      orderBy: $orderBy
      text: $text
      where: $where
    ) {
      pageInfo {
        hasNextPage
        endCursor
        total
        count
      }
      edges {
        node {
          id
          exhibitor
          hall_name
          block
          corridor
          stand_number
          status
          created_at
          updated_at
          graphic_list_id
          complete_at
          comment
          relStand {
            id
            shelf_number
            file_graphic
            file_info
            file_photo
            file_stand_plan
            getQRCode
          }
          relPackedUser {
            id
            name
            surname
          }
          relGraphicList {
            id
            title
          }
        }
      }
    }
  }
`;
